import React from 'react';

import './certificate-modal__form.scss';

interface Props {
    children: React.ReactNode | Array<React.ReactNode>;
}

export const CertificateModalForm = ({ children }: Props) => <div className="certificate-modal__form">{children}</div>;
